import { Component } from '@angular/core';
import { Product, ProductScope } from '@spartacus/core';
import { CurrentProductService } from '@spartacus/storefront';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'product-key-feature',
  templateUrl: './product-key-feature.component.html',
  styleUrl: './product-key-feature.component.scss',
  standalone: false,
})
export class ProductKeyFeatureComponent {
  subscription = new Subscription();
  product$: Observable<Product | null> = this.currentProductService.getProduct([
    ProductScope.DETAILS,
    ProductScope.PRICE,
  ]);

  constructor(protected currentProductService: CurrentProductService) {}
}
